
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InsurancePage from "../pages/insurance/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/insurance-benefits",
    element: <InsurancePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
